import { Box, MenuItem, Select, FormControl, Input } from "@mui/material"

import { makeStyles } from "tss-react/mui"
import React, { useState } from "react"
import { blueGrey } from "../../../../mp-core/themes/palette"

const styles = makeStyles()(({ palette, spacing }) => ({
  root: {
    // padding: spacing(4, 3)
  },
  select: {
    // minWidth: "150px",
    background: palette.common.white,
    borderRadius: "2px",
    paddingLeft: spacing(3),
    paddingTop: spacing(2),
    paddingBottom: spacing(2),
    border: `1px solid ${blueGrey[200]}`
  },
  icon: {
    color: palette.primary[500],
    fontSize: "20px",
    top: "auto"
  }
}))

type optionsType = {
  label: string | number
  id: string | number
}
interface StudentFilterProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  option?: optionsType[]
  selectedOption?: string | number
  filterName?: string
  limit?: number
  "aria-label"?: string
}

const StudentFilter: React.FC<React.PropsWithChildren<StudentFilterProps>> = ({
  option,
  onChange,
  selectedOption,
  filterName = "Filter By Students",
  "aria-label": ariaLabel
}) => {
  const [val, setVal] = useState(selectedOption)
  const { classes } = styles()

  const menuProps = {
    // getContentAnchorEl: null
  }
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (filterName === "Number of Students") {
      if (e.target?.value) {
        setVal(e.target?.value)
        onChange(e)
      }
    } else if (e) {
      setVal(e.target?.value)
      onChange(e)
    }
  }
  return (
    <Box>
      <Select
        classes={{
          select: classes.select,
          icon: classes.icon
        }}
        disableUnderline
        MenuProps={menuProps}
        displayEmpty
        renderValue={val !== "" ? undefined : () => filterName}
        value={val}
        onChange={handleChange}
        variant="standard"
        SelectDisplayProps={{ role: "combobox", "aria-label": ariaLabel }}
      >
        {!!filterName && (
          <MenuItem key={filterName} value={""}>
            {filterName}
          </MenuItem>
        )}
        {option?.map((item: any, v: number) => (
          <MenuItem key={v} value={item.id}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  )
}
export default StudentFilter
